<nz-spin [nzSpinning]="loading$ | async">
  <form nz-form class="form" [formGroup]="templateLogsFilterForm">
    <div class="drawer-form-wrapper">
      <div class="form-grid-secondary">
        <nz-form-item>
          <nz-form-label nzFor="template">Template</nz-form-label>
          <nz-form-control>
            <nz-select
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select template"
              [nzOptionOverflowSize]="7"
              formControlName="templateId">
              @for (template of templateList; track template) {
                <nz-option
                  [nzLabel]="template.templateName"
                  [nzValue]="template.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="type">Type</nz-form-label>
          <nz-form-control>
            <nz-select
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select type"
              [nzOptionOverflowSize]="7"
              formControlName="dataAuditTypeId">
              @for (type of auditTypeList; track type) {
                <nz-option
                  [nzLabel]="type.value"
                  [nzValue]="type.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="user">User</nz-form-label>
          <nz-form-control>
            <nz-select
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select user"
              [nzOptionOverflowSize]="7"
              formControlName="userId">
              @for (user of userList; track user) {
                <nz-option
                  [nzLabel]="user.userName"
                  [nzValue]="user.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="user">Date</nz-form-label>
          <nz-form-control>
            <nz-date-picker
              [nzSuffixIcon]="customSuffix"
              nzPlaceHolder="Select Date"
              class="with-suffix"
              formControlName="dateFilter"
              nzFormat="MM/dd/yyyy"></nz-date-picker>
            <ng-template #customSuffix>
              <svg-icon
                [title]="'Select date'"
                src="/assets/icon/icon-calendar.svg"
                class="icon s-16"></svg-icon>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div class="drawer-footer">
      <button nz-button type="reset" nzType="default" (click)="reset()">
        Reset
      </button>
      <button nz-button type="button" nzType="primary" (click)="apply()">
        Apply
      </button>
    </div>
  </form>
</nz-spin>
